import { Stack } from '@mui/material';
import { Dispatch, SetStateAction, useCallback } from 'react';
import { ListOptions } from './ListOptions';
import { SingleSelectOption } from './types';

type Props = {
  isOpen: boolean;
  closeDropdown: () => void;
  activeIndex: number;
  setActiveIndex: Dispatch<SetStateAction<number>>;
  scrollBackToMainBar?: () => void;
  options: SingleSelectOption[];
  selectedOption?: string;
  onChange: (value: string) => void;
  label: string;
};

export const ListBox = ({
  isOpen,
  closeDropdown,
  activeIndex,
  setActiveIndex,
  scrollBackToMainBar,
  options,
  selectedOption,
  onChange,
  label,
}: Props) => {
  const handleSelectOption = useCallback(
    (value: string) => {
      closeDropdown();

      setTimeout(() => {
        onChange(value);
      }, 100);

      if (scrollBackToMainBar) {
        scrollBackToMainBar();
      }
    },
    [onChange, closeDropdown, scrollBackToMainBar],
  );

  const moveOnList = (directionMove: 1 | -1) =>
    setActiveIndex(index => (index + directionMove + options.length) % options.length);

  const onKeyList = (e: React.KeyboardEvent) => {
    e.preventDefault();
    switch (e.key) {
      case 'ArrowDown':
        moveOnList(1);
        break;
      case 'ArrowUp':
        moveOnList(-1);
        break;
      case 'Home':
        setActiveIndex(0);
        break;
      case 'End':
        setActiveIndex(options.length - 1);
        break;
      case 'Escape':
        closeDropdown();
        break;
    }
  };

  return (
    <Stack
      id={`${label}-dropdown-list`}
      role="listbox"
      aria-labelledby={`${label}-dropdown-button`}
      tabIndex={0}
      sx={{ maxHeight: '200px', overflowY: 'auto' }}
      onKeyDown={onKeyList}
    >
      <ListOptions
        isOpen={isOpen}
        activeIndex={activeIndex}
        handleSelectOption={handleSelectOption}
        options={options}
        selectedOption={selectedOption}
      />
    </Stack>
  );
};
